const DEFAULT_STATE = { isDirty: false };

const FORM_SET_IS_DIRTY = 'FORM_SET_IS_DIRTY';
export const setFormIsDirty = isDirty => dispatch => {
  dispatch({ type: FORM_SET_IS_DIRTY, isDirty });
};

const FORM_RESET_IS_DIRTY = 'FORM_RESET_IS_DIRTY';
export const resetFormIsDirty = () => dispatch => {
  dispatch({ type: FORM_RESET_IS_DIRTY });
};

const formReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FORM_SET_IS_DIRTY: {
      return {
        isDirty: action.isDirty
      };
    }

    case FORM_RESET_IS_DIRTY: {
      return DEFAULT_STATE;
    }

    default:
      return state;
  }
};

export const selectFormDirty = state => state.isDirty;

export default formReducer;
